<template>
    <div>
      <v-container>
    
       <v-row>
   
         <v-col cols="12">
                   <v-card elevation="1">
                  <v-toolbar elevation="0">
                    <v-icon left color="primary">mdi-chart-bar</v-icon> Sales Report  
                   
                  
                  </v-toolbar>
                
                  <v-toolbar dense elevation="1" class="mt-2">
                 
                          <v-icon left>mdi-calendar-month</v-icon> Covered Date: {{$moment(from_date).format("MMM DD, YYYY")}} - {{$moment(to_date).format("MMM DD, YYYY")}}  
                 
                     <v-spacer/>
                    <span style="width: 190px;" class="mr-2">
                           <v-menu
                                  ref="menu"
                                  v-model="menu"
                                  :close-on-content-click="false"
                                  :return-value.sync="date"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="from_date"
                                      label="From Date"
                                      single-line
                                       prepend-icon="mdi-calendar-month"
                               dense
                               outlined
                               hide-details
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="from_date"
                                    no-title
                                    scrollable
                                    @input="menu = false"
                                  >
                                
                                  </v-date-picker>
                                </v-menu>
                    </span>
                    <span style="width: 190px;">
                           <v-menu
                                  ref="menu2"
                                  v-model="menu2"
                                  :close-on-content-click="false"
                                  :return-value.sync="date"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="to_date"
                                      label="To Date"
                                      single-line
                                       prepend-icon="mdi-arrow-right"
                               dense
                               outlined
                               hide-details
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="to_date"
                                    no-title
                                    scrollable
                                    @input="menu2 = false, QrySales()"
                                  >
                                
                                  </v-date-picker>
                                </v-menu>
                    </span>
                  </v-toolbar>
                  <v-card-text  v-if="!IsEmpty(items)">

                      <v-row>
                    <v-col cols="3">
                           <v-card tile>
                            <v-card-text class="pa-1">
                        
                            <table class="va-table">
                                <tr>
                                    <td class="text-center bg-success" width="90"> <v-icon center x-large color="white">mdi-cash-register</v-icon></td>
                                    <td class="text-center pa-2">
                                        <span class="text-h6 font-weight-bold">{{$money(SALES)}}</span>
                                        <v-divider />
                                        <span class="def-font text-success ">Total Sales</span>
                                    </td>
                                </tr>
                            </table>
                          </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="3">
                           <v-card tile>
                            <v-card-text class="pa-1">
                        
                            <table class="va-table">
                                <tr>
                                    <td class="text-center bg-info" width="90"> <v-icon center x-large color="white">mdi-finance</v-icon></td>
                                    <td class="text-center pa-2">
                                        <span class="text-h6 font-weight-bold">{{$money(SALES - TOTALCOST)}}</span>
                                        <v-divider />
                                        <span class="def-font text-info ">Gross Profit</span>
                                    </td>
                                </tr>
                            </table>
                          </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="3">
                           <v-card tile>
                            <v-card-text class="pa-1">
                        
                            <table class="va-table">
                                <tr>
                                    <td class="text-center bg-primary" width="90"> <v-icon center x-large color="white">mdi-clipboard-list-outline</v-icon></td>
                                    <td class="text-center pa-2">
                                        <span class="text-h6 font-weight-bold">{{$count(IsEmpty(items)?0:items.length)}}</span>
                                        <v-divider />
                                        <span class="def-font text-primary ">Transactions</span>
                                    </td>
                                </tr>
                            </table>
                          </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="3">
                           <v-card tile>
                            <v-card-text class="pa-1">
                        
                            <table class="va-table">
                                <tr>
                                    <td class="text-center bg-accent" width="90"> <v-icon center x-large color="white">mdi-cash-multiple</v-icon></td>
                                    <td class="text-center pa-2">
                                        <span class="text-h6 font-weight-bold">{{$money(TOTALCOST)}}</span>
                                        <v-divider />
                                        <span class="def-font text-accent ">Total Cost</span>
                                    </td>
                                </tr>
                            </table>
                          </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                   <v-row>
               <v-col cols="12" sm="8">
                    <v-card tile>
                       <v-card-text>
                          <span class="font-weight-bold"> Sales Trend</span>
                          <v-divider />
                          <div>
                               <chart-gross :rawdata="CHARTDATA" :show="chart"/>

                          </div>
                         </v-card-text> 
                    </v-card>
                    
               </v-col>
               <v-col cols="12" sm="4">
                     <v-card tile>
                       <v-card-text>
                          <span class="font-weight-bold">Sales by Payment Method</span>
                          <v-divider />
                          <chart-payments :rawdata="payment_methods" :show="pie"/>
                         </v-card-text> 
                    </v-card>
               </v-col>
        </v-row>
                
                  <table class="va-table va-table-border-bot mt-4" >
                     <tr>
                        <!-- <th width="30"></th> -->
                        <th>Number</th>
                        <th>Customer</th>
                        <th>Type</th>
                        <th width="170">Date</th>
                        <th>Cashier</th>
                        <th class="text-center">Status</th>
                         <th class="text-center">Payment</th>
                        <th class="text-right">Amount</th>
                     </tr> 
                     <tr v-for="(item, index) in FILTEREDITEMS" :key="index">
                        <!-- <td class="text-center">
                          <v-icon small  @click="selectedID=item.id,state='modify',form=true">mdi-text-box-edit</v-icon></td> -->
                       
                        <td>
                            {{item.id}}
                        </td>
                        <td> {{item.customer_data.fullname}}</td>
                        <td :class="TEXT_COLOR(item.type)" class="font-italic"> {{item.type}}</td>
                          <td> {{$moment(item.created_at).format("YYYY-MM-DD HH:MM A")}}</td>
                        <td class="font-italic">
                            {{item.fullname}}
                        </td>
                        <td :class="STATUS_BG(item.status)" class="text-center text-white">{{item.status}}</td>
                        <td :class="STATUS_BG(item.payment_status)" class="text-center text-white"> {{item.payment_status}}</td>
                        <td class="text-right"> {{$money(item.total_amount)}}
                            <p v-if="item.discount_request =='Request For Discount' && item.payment_status =='Unpaid'" class="ma-0 font-italic text-primary font-weight-thin" >
                                 {{ item.discount_request }}
                            </p>
                        </td>
                     </tr>
                    
                  </table>
                 
                    <div class="pa-4">
                          <span class="mx-2">Item(s) Found: {{SEARCHFILTER.length}}</span>|
                          <span class="mx-2">
                            Rows per page: <select v-model="view.per_page" @change="view.current_page=1"  class="va-select">
                              <option v-for="fruit in [5,10,15,20,50,100,1000]" :key="fruit" :value="fruit">
                                {{ fruit }}
                              </option>
                            </select>
                          </span>
                          |
                            <span class="mx-2">
                            <v-icon left small @click="view.current_page>1?view.current_page=view.current_page-1:view.current_page=1">mdi-arrow-left</v-icon>
                            {{view.current_page}}/{{ PAGE_COUNT}}
                            <v-icon right small @click="view.current_page<PAGE_COUNT?view.current_page=view.current_page+1:view.current_page=PAGE_COUNT">mdi-arrow-right</v-icon>
                             </span>   
                    </div>
                     
                  </v-card-text>
                  <v-card-text class="text-center" v-else>
                          <div class="font-weight-thin font-italic pa-5 mt-5"  >
                            <a  @click="state='new', form=true">Add your first sales...  <v-icon  right small color="primary">mdi-pencil</v-icon></a>
                          </div>
                    </v-card-text>
             
                </v-card>
             </v-col>
       </v-row>
       </v-container>
        <va-sales-form :show="form" :selectedID="selectedID"  :state="state" @DialogEvent="formEvent" />
        
     </div>
   </template>
   <script>
   import {
     mapMutations
   } from 'vuex'
     export default {
       data: () => ({
           form: false,
           menu: false,
           menu2: false,
           date:"",
           from_date:"",
           to_date:'',
           search:"",
           cost:[],
           selectedID:  null,
           trans_dailog: false,
           areaform: false,
           state: 'new',
           invetory:{},
           items:[],
           view: {
              per_page: 50,
              current_page: 1,
              pagination: true
           },
           USERID: 0,
           chart_data:[],
           payment_methods: [],
           chart: false,
           pie: false,
       }),
       beforeCreate: function () {
         if (!this.$session.exists()) {
           this.$router.push('/')
         } 
       },
       created() {
          if (this.$session.exists()) {
             this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
             this.setLoggedIn(true) 
             this.from_date =  this.$moment().subtract(7, 'days').format("YYYY-MM-DD")
             this.to_date =  this.$moment().format("YYYY-MM-DD")
            this.CHECKPAGEPERMISSION()
             this.SETVARS()
             this.USERID  = this.$IsNum(this.$session.get('userID'))
            this.QrySales()
            
           }
       },
       computed:{
        TOTALCOST(){
           if(this.IsEmpty(this.cost)) { return 0}
        var total = this.cost.reduce((res,item)=>{
              res = this.$IsNum(res) +  this.$IsNum(item.cost)
              return res
        }, 0)
        return total
        },
         FILTEREDITEMS(){
           if(this.IsEmpty(this.items)) { return []}
            if(this.items.length == 0) {
              return []
            }
            var pageArr = this.$pagination(this.SEARCHFILTER,this.view.per_page)
            return pageArr[this.view.current_page - 1]
         },
         PAGE_COUNT(){
          var pageArr = this.$pagination(this.SEARCHFILTER,this.view.per_page)
          return pageArr.length
         },
         SEARCHFILTER(){
            if(this.search != "") {
              return this.$crawler(this.items, this.search)
            } else {
              return this.items
            }
         },
           CANCELLED(){
             if(this.IsEmpty(this.items)) { return 0}
            var total = this.items.reduce((res,item)=>{
              if(item.status == 'Cancelled')
                  res = this.$IsNum(res) +  1
                  return res
            }, 0)
            return total
          },
           INPROGRESS(){
             if(this.IsEmpty(this.items)) { return 0}
            var total = this.items.reduce((res,item)=>{
              if(item.status == 'In Progress')
                  res = this.$IsNum(res) +  1
                  return res
            }, 0)
            return total
          },
          COMPLETED(){
            if(this.IsEmpty(this.items)) { return 0}
            var total = this.items.reduce((res,item)=>{
              if(item.status == 'Completed' && item.payment_status == 'Paid')
                  res = this.$IsNum(res) +  1
                  return res
            }, 0)
            return total
          },
        SALES(){
           if(this.IsEmpty(this.items)) { return 0}
            var total = this.items.reduce((res,item)=>{
              if(item.status == 'Completed' || item.status == 'Active')
                  res = this.$IsNum(res) +  this.$IsNum(item.total_amount)
                  return res
            }, 0)
            return total
          },
         CHARTDATA(){
             if(this.IsEmpty(this.chart_data)) { return []}
            return this.chart_data
        } 
       },
       methods: {
         ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn','setVariables']),
       
        imagePreview(images){
          console.log("images",images)
         if(images == null) {
          return  this.$store.state.nopreview
         }
           if(images.length == 0) {
          return  this.$store.state.nopreview
         }
         let arr = this.ViewUploadedfiles(images)
         return arr[0]
        },
         formEvent(){
             this.form = false
             this.getItems()
         },

         getChartData() { 
           this.chart_data = []
            this.QUERY('sales',`select to_date(created_at::text,'YYYY-MM-DD') as sales_date, sum(total_amount) as amount from sales where (payment_status = 'Paid' and status='Completed') 
            and to_date(created_at::text,'YYYY-MM-DD') >= '${this.from_date}' and to_date(created_at::text,'YYYY-MM-DD') <= '${this.to_date}' 
group by to_date(created_at::text,'YYYY-MM-DD') order by sales_date asc`, (res)=>{
              this.chart_data = res.results
            //  console.log("chart_data", chart_data)
                 setTimeout(()=>{
                this.chart = true
                },1000)
            })
        },
        QrySales(){
          if(this.IsEmpty(this.from_date)) {
            this.from_date = this.$moment().format('YYYY-MM-DD')
          }
           if(this.IsEmpty(this.to_date)) {
            this.to_date = this.$moment().format('YYYY-MM-DD')
          }
          console.log("from_date", this.from_date)
        console.log("to_date", this.to_date)
          this.VA_ALERT('info', 'Loading sales', 'progress', 100, 1500)
           this.items = []
            this.QUERY('sales',`select s.id, u.fullname, s.customer_data, s.created_at, s.status, s.type, s.invoice_no, s.total_amount, s.payment_status,s.discount_request 
from sales s  left join users u on u.id=s.sales_person 
where to_date(created_at::text,'YYYY-MM-DD') >= '${this.from_date}' and to_date(created_at::text,'YYYY-MM-DD') <= '${this.to_date}' order by id desc`, (res)=>{
             
              this.items = res.results
              this.chart = false
              this.pie = false
              this.getChartData()
              this.getPaymentMethods()
              this.getCost()
            })
        },
         getCost(){
          this.GET_COST(this.from_date, this.to_date, (res)=>{
            this.cost = res.results
          })
        },
         getPaymentMethods() { 
           this.payment_methods = []
            this.QUERY('sales',`select coalesce(payment_method, 'Others') as method, sum(total_amount) as amount from sales 
            where payment_status = 'Paid' and (to_date(created_at::text,'YYYY-MM-DD') >= '${this.from_date}' and to_date(created_at::text,'YYYY-MM-DD') <= '${this.to_date}')
group by payment_method order by payment_method`, (res)=>{
              this.payment_methods = res.results
              setTimeout(()=>{
                this.pie = true
                },1500)
            })
        }
      
       }
     }
   </script>